import { InjectionToken } from '@angular/core';

export const REPORT_URL = new InjectionToken<string>('REPORT_URL');
